import { initialState } from "./initialState";
import {
  CLEAR_ROW,
  DOWNLOAD_BATCHES_DATA_REQUEST,
  FETCH_BATCH_METADATA_REQUEST,
  FETCH_BATCHES_REQUEST,
  FETCH_PARTIAL_BATCHES_REQUEST,
  GET_BATCH_DETAILS,
  GET_PRODUCT_META_LIST,
  GET_SITE_META_LIST,
  GET_MFG_META_LIST,
  GET_ALL_BATCHES,
} from "./types";

const batchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BATCHES_REQUEST:
      return { ...state, batches: action.payload };

    case FETCH_PARTIAL_BATCHES_REQUEST:
      return { ...state, partialBatches: action.payload };

    case FETCH_BATCH_METADATA_REQUEST:
      return {
        ...state,
        batchMetaData: action.payload,
      };

    case DOWNLOAD_BATCHES_DATA_REQUEST:
      return {
        ...state,
        downloadedBatchesData: action.payload,
      };

    case GET_BATCH_DETAILS:
      return {
        ...state,
        batchDetails: action.payload,
      };
    case GET_PRODUCT_META_LIST:
      return {
        ...state,
        productMetaList: action.payload,
      };
    case GET_SITE_META_LIST:
      return {
        ...state,
        siteMetaList: action.payload,
      };
    case GET_MFG_META_LIST:
      return {
        ...state,
        mfgMetaList: action.payload,
      };

    case GET_ALL_BATCHES:
      return {
        ...state,
        allBatches: action.payload,
      };
    
    
      
    case CLEAR_ROW:
      return {
        ...state,
        batches: {
          loader: false,
        },
      };

    default:
      return state;
  }
};

export default batchReducer;
